import MuiPagination from './MuiPagination';

export default {
  MuiPagination  
};
